import { api } from '@/shared/api'
import {
    GenerateSiteLinkDto,
    CreateUTMDto,
    UtmSourceDto,
    UtmMediumDto,
    UtmCampaignDto,
    UtmContentDto,
    UpdateSiteLinkDto,
    DeleteSiteLinkResponse,
    MoveSiteLinksDto,
    MoveSiteLinksResponse,
} from '@synapex/shared'
import { SiteLinkWithAnalyticsType } from '../site-links-group/site-links-group.types'
import { SiteLink } from '@synapex/prisma/client'
import { arrayFilterMap, UtmKey } from '@synapex/tools/utils'
import { utmId } from '../invite-links-group/invite-links-group.query.constants'
// import { Link } from '@synapex/shared2/gateway-rest-api'

export type UtmReply = {
    key: UtmKey
    id: string
    name: string
    color: string
    created_at: Date
}

class SiteLinksService {
    async moveSiteLinks(
        moveDto: MoveSiteLinksDto
    ): Promise<MoveSiteLinksResponse> {
        return await api.post('/analytics/site-links/move-group', moveDto)
    }

    async deleteSiteLink(id: number): Promise<DeleteSiteLinkResponse> {
        return await api.delete(`/site/site-links/${id}`)
    }

    async generateSiteLink(
        data: GenerateSiteLinkDto
    ): Promise<SiteLinkWithAnalyticsType> {
        return await api.post('/site/site-links', data)
    }

    async updateSiteLink(data: UpdateSiteLinkDto): Promise<SiteLink> {
        const response: SiteLink = await api.put('/site/site-links', data)
        return response
    }

    // async getSiteLinksByGroupId(
    //     groupId: number,
    //     siteId: number
    // ): Promise<Link.SiteLinkManyReply> {
    //     return await api.get(`/link/site`, {
    //         params: {
    //             groupId,
    //             siteId,
    //         },
    //     })
    // }

    async createUTM(key: UtmKey, data: CreateUTMDto): Promise<any> {
        return await api.post(`/site/utm/${key}`, data)
    }

    async getUTM(key: UtmKey, siteLinksGroupId: number): Promise<UtmReply[]> {
        return await api
            .get<
                | Array<UtmSourceDto>
                | Array<UtmMediumDto>
                | Array<UtmCampaignDto>
                | Array<UtmContentDto>
            >(`/site/utm/${siteLinksGroupId}/${key}s`, {
                params: {
                    siteLinksGroupId,
                },
            })
            .then((reply) =>
                arrayFilterMap<
                    | UtmSourceDto
                    | UtmMediumDto
                    | UtmCampaignDto
                    | UtmContentDto,
                    UtmReply
                >(reply, (item) => {
                    const utmKeyId = utmId(key)

                    //@ts-expect-error bad code
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    const id: number | undefined = item[utmKeyId]

                    if (!id) {
                        return undefined
                    }

                    return {
                        key,
                        name: item.name,
                        created_at: item.created_at,
                        color: item.color,
                        id: id.toString(),
                    }
                })
            )
    }

    async addAdminContact(
        siteLinkId: number,
        telegramUsername: string,
        shouldSelectAdmin?: boolean
    ): Promise<any> {
        return await api.post(`/site/${siteLinkId}/admin-contacts`, {
            telegramUsername,
            shouldSelectAdmin,
        })
    }

    async deleteAdminContact(
        siteLinkId: number,
        adminContactId: number
    ): Promise<any> {
        return await api.delete(
            `/site/${siteLinkId}/admin-contacts/${adminContactId}`
        )
    }
}

export const siteLinksService = new SiteLinksService()
